import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
import { getData, postData } from "../../Service/ApiMethod";
import { My_Subscription, Payment_sheet, Subscription_Plan, Recruiter_Profile_Status, Credit_BALANCE } from "../../Service/service";
import BackBar from "../home/BackBar";
import { useTranslation } from "react-i18next";
// import StripeCheckout from "react-stripe-checkout";
// import axios from 'axios';
// import { async } from "react-input-emoji";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Modal, Button } from 'react-bootstrap';
import CheckoutForm from "./CheckoutForm";
import { lang } from "../../lang";
 
// import CheckoutForm from "./CheckoutForm";
const promise = loadStripe("pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8");
// const stripePromise = loadStripe("pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8");
const Subcription = () => {
  const [ln,setLn] = useState('en') 
  const [subscriptionData, setSubscriptionData] = useState()
  const [planValue, setPlanValue] = useState(-1)
  // const [vipTick, setVipTick] = useState(false)
  // const [premiumTick, setPremiumTick] = useState(false)
  const [myProfile, setMyprofile] = useState({})
  const [activePlan, setActiveplan] = useState(1)
  const [checkPlan, setCheckplan] = useState(false)
  const [plans, setPlans] = useState([])
  const { t } = useTranslation();

  // const navigate = useNavigate()
  console.log('planValue', planValue)

  // const [datax, setDatax] = useState([])
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  // const checkout = async () =>{
  //   await fetch ('https://staging.jobportalapi.atwpl.com/payment_sheet/', {
  //     method:"POST",
  //     headers:{
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({email: 'sonalsaurabh67@gmail.com'})
  //   }).then((response) => {
  //     return response.json();
  //   }).then(async res => {
  //     const response = res;
  //     if (response.status_code === 200) {
  //       setDatax(response.data);
  //       // console.log('responsezzzzddddzz', res.data)
  //     } else {
  //       console.log('Error', response.message);
  //     }
  //   })
  //   .catch(error => {
  //     console.log(error);
  //   });
  // }

  // const handleToken = async (token) => {
  //   const response = await axios.post('https://staging.jobportalapi.atwpl.com/payment_sheet/', {
  //     token,
  //     email: token?.email,
  //     amount: 1000 // amount in cents
  //   });
  //   console.log(response);
  // }
  // const handleToken = async (token) => {
  //   console.log(token ,)
  //   const response = await axios.post('https://staging.jobportalapi.atwpl.com/payment_sheet/', {
  //     token,
  //     email: token?.email,

  //   });
  //   console.log(response,"espppppppppp");
  // }
  // const [clientSecret, setClientSecret] = useState("");
  const planId = useRef(0)
  const amountPlans = useRef(0)

  // const handleToken = async (token) => {
  //   console.log(token, "tokenaaaaaa")
  //   // const obj = {
  //   //   email: token?.email
  //   // }

  //   // let obj = {
  //   //   serviceId: 2,
  //   //   subscription_id: planId.current,
  //   //   txnAmount: amountPlans.current * 100,
  //   //   gateWayName: "card",
  //   //   paymentMode: 1,
  //   //   user_type: "RECRUITER"
  //   // };
  //   // console.log(obj, "okkkkkkkkkkkkkkkkkkkkkkk");
  //   // await postData(obj, Payment_sheet)
  //   //   .then(res => res.json())
  //   //   .then(data => {
  //   //     console.log("resp", data)
  //   //     // let val = data.data.customer
  //   //     // // redirectToCheckout(val)
  //   //     // setClientSecret(val)
  //   //     // setSubscriptionData(data.data)
  //   //   })
  // }


  // const redirectToCheckout = async(sessionId) => {
  //   const stripe = await window.Stripe('pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8');
  //   stripe.redirectToCheckout({ sessionId });
  // };




  const getSubscriptionData = () => {

    getData(My_Subscription)
      .then(res => res.json())
      .then(data => {
        console.log("subscription", data.data)
        const freePlan = data.data.plan_details.find(plan => plan.plan_type === "FREE");
        const vipPlan = data.data.plan_details.find(plan => plan.plan_type === "VIP");
        const premiumPlan = data.data.plan_details.find(plan => plan.plan_type === "PREMIUM");

        if (freePlan && vipPlan && premiumPlan) {
          data.data.plan_details.splice(data.data.plan_details.indexOf(freePlan), 1);
          data.data.plan_details.splice(0, 0, freePlan);
          data.data.plan_details.splice(data.data.plan_details.indexOf(vipPlan), 1);
          data.data.plan_details.splice(1, 0, vipPlan);
          data.data.plan_details.splice(data.data.plan_details.indexOf(premiumPlan), 1);
          data.data.plan_details.splice(2, 0, premiumPlan);
        }
        let ddd = data.data.plan_details.map(plan => {
          return {
            ...plan,
            is_Selected: false
          };
        });
        setPlans(ddd)
        console.log(data.data.plan_details, "okjhuhuh", ddd);
        setSubscriptionData(data.data)
      })
  }

  const getProfile = () => {
    getData(Credit_BALANCE)
      .then(res => res.json())
      .then(data => {
        console.log("profilemy", data.data)
        setActiveplan(data.data.credit_balance_history[0].plan_id)
        setMyprofile(data.data)
      })
  }

  console.log('subscriptionData', subscriptionData)

  // const handlePlan = () => {
  //   const obj = {
  //     subscription: planValue
  //   }
  //   if (!planValue) {
  //     Swal.fire('Plaese select your plan')
  //   } else {
  //     postData(obj, Subscription_Plan)
  //       .then(response => response.json())
  //       .then(data => {
  //         console.log('upgrade plan', data.data)
  //         // navigate('/credit')
  //       })
  //       .catch((err) => {
  //         console.log(err.message)
  //       })
  //   }

  // }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    // const currentUrl = window.location.href
    // console.log(currentUrl, "58888888")
    setShow(true)
  };



  useEffect(() => {
    getSubscriptionData()
    getProfile()
  }, [])

  // const [succeeded, setSucceeded] = useState(false);
  // const [error, setError] = useState(null);
  // const [processing, setProcessing] = useState("");
  // const [disabled, setDisabled] = useState(true);
  const [clientSecrets, setClientSecret] = useState("");
  // 2️⃣ Store reference to Stripe
  // const stripe = useStripe();
  // const elements = useElements();

  // const handleChange = async (event) => {
  //   // 4️⃣ Listen for changes in the CardElement and display any errors as the customer types their card details
  //   setDisabled(event.empty);
  //   setError(event.error ? event.error.message : "");
  // };
  // const handleSubmit = async (ev) => {
  //   ev.preventDefault();
  //   setProcessing(true);
  //  // 5️⃣ Confirm Card Payment.
  //   const payload = await stripe.confirmCardPayment(clientSecret, {
  //     payment_method: {
  //       card: elements.getElement(CardElement),
  //     },
  //   });
  //   if (payload.error) {
  //     setError(`Payment failed ${payload.error.message}`);
  //     setProcessing(false);
  //   } else {
  //     setError(null);
  //     setProcessing(false);
  //     setSucceeded(true);
  //   }
  // };


  const checkValss = () => {
    let obj = {
      serviceId: 2,
      subscription_id: planId.current,
      txnAmount: amountPlans.current * 100,
      gateWayName: "card",
      paymentMode: 1,
      user_type: "RECRUITER"
    };
    window.fetch("https://api.catzapp.com/manage_plan_txn/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
      },
      body: JSON.stringify(obj),
    }).then((res) => {
      return res.json();
    }).then((data) => {
      console.log("sdeee", data.data.payment_intent.client_secret);
      setClientSecret(data.data.payment_intent.client_secret);
    });
  }






  return (
    <>
      <div className="wrapped-content-area pt-3">
        <BackBar title={t("Upgrade Subcription")} />
        <div className="container-fluid">
          {/* <div className="row subcription-section mt-3 p-0">
            <div className="col-4 col-lg-6 d-none-mb"></div>
            <div className="col-8 col-lg-6 px-0">
              <div className="d-flex subscription-justify">
                <div className="free-subs">
                  <p className="text">{t('Free')}</p>
                </div>
                <div className="vip-subs">
                  <div className="vip" >{t('VIP')}</div>
                </div>
                <div className="premium-subs">
                  <div className="premium-box">{t('Premium')}</div>
                </div>
              </div>
            </div>
          </div> */}
          <hr className="divider" />
          {/* 
          {subscriptionData?.features_details?.map((item, i) => {
            return (
              <>
                <div className="row align-items-center" key={i}>
                  <div className="col-4 col-lg-6">
                    {" "}
                    <div className="text">{item?.feature_name}</div>
                  </div>

                  <div className="col-8 col-lg-6">
                    <div className="d-flex justify-content-around">
                      {item?.free ? <img src="./images/blue-tick.png" alt="" /> : <img src="./images/grey-cross.png" alt="" />}
                      {item?.vip ? <img src="./images/blue-tick.png" alt="" /> : <img src="./images/grey-cross.png" alt="" />}
                      {item?.premium ? <img src="./images/blue-tick.png" alt="" /> : <img src="./images/grey-cross.png" alt="" />}
                    </div>
                  </div>
                </div>
                <hr className="divider mb-2 mt-1" />
              </>
            )
          })} */}






          {plans &&

            <div className="d-flex mt-3 plan-outer" style={{ display: 'flex', justifyContent: 'center' }}>
              {
                plans.map((its, i) => {
                  console.log("okkkkkaaaaaaaaa", its);
                  return (
                    <div className="plan mr-3-mb-0" style={{ backgroundColor: its?.plan_id == activePlan ? "#F2F7FF" : "#EAEAEB" }} onClick={() => {
                      console.log(i, "ddddddd");

                      const valu = plans.map((it, index) => {
                        if (i == index) {
                          it.is_Selected = true
                        } else {
                          it.is_Selected = false
                        }
                        return { ...it }
                      })
                      console.log(valu, "console.log(valu);", its);
                      setPlans(valu)
                      setCheckplan(true)
                      setPlanValue(i + 1)
                      planId.current = its?.id
                      amountPlans.current = its?.amount
                      checkValss()
                      // setVipTick(false)
                      // setPremiumTick(true)
                    }}>
                      <p className="text">{its?.plan_id == activePlan ? lang && Object.keys(lang).length > 0 ? lang[ln]?.SearchEvents["Current Plan"]:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation["Upgrade Subcription"]:""}</p>
                      <p className="premium-box mt-2" style={{ width: "auto" }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation[its?.plan_type]:""} </p>
                      <p className=" mt-3">{lang && Object.keys(lang).length > 0 ? lang[ln]?.Home['Credits']:""} {its?.token_credits}</p>
                      <p className="heading mt-3">€ {its?.amount}</p>
                      <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['valid for ']:""} {its.validity}{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['days']:""}</p>
                      {
                        its.plan_type != "FREE" ? its.plan_type != "Monthly Plan" ? (<div style={{ marginTop: 20 }}>
                          <h5>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Feature']:""}</h5>
                          <p>1){lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Includescredits']:""}</p>
                          <p>2){lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Credits can be carried forward each month']:""}</p>
                        </div>) : (<div>
                          <h5>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Feature']:""}</h5>
                          <p>1){lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Includescredits']:""}</p>
                        </div>) : null
                      }
                      {its.is_Selected == true ? (<div className='selectedTick'>
                        <i className="fa-solid fa-circle-check" />
                      </div>) : null
                      }
                    </div>
                  )
                })
              }

            </div>
          }


          <div className="flex-center my-3">
            {/* <StripeCheckout
          onClick={checkout}
          stripeKey="pk_test_51Mit3xSHOcHxqHqIfzTJRYb9g6e4xbgg2Lslsgf3NUj9YCKu76gMLqXpuGdV7loiSj9acoA0LolSGvYkVX5rWR3M00ZiG2ZWwx" 
        /> */}





            <button className="theme-btn px-5" onClick={handleShow}>{t('Upgrade Now')}</button>




            {/* <StripeCheckout
              token={handleToken}
              stripeKey="pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8"
              name="Catzapp"
              //  description="Product or Service Description"
              // amount={1000} // amount in cents
              // currency="Inr"
              // email="sonalsaurabh67@gmail.com"

              label={t("Subscribe Now")}

              billingAddress={false}
              zipCode={true}
            // shippingAddress

            /> */}
            <Modal className="cardDetailModal" show={show} onHide={handleClose} style={{  }}>
              <Modal.Header closeButton>
                <h5>Enter Card Details</h5>
              </Modal.Header>
              <Modal.Body>
                <div className="App">
                  <Elements stripe={promise}>
                    <CheckoutForm clientSecretss={clientSecrets} checkVal={() => { console.log(false) }}/>
                  </Elements>
                </div>
              </Modal.Body>
            </Modal>
            {/* {clientSecret && (
              <Elements options={options} stripe={stripePromise}>
                <CheckoutForm />
              </Elements>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Subcription;
